module.exports = __webpack_public_path__ + "static/media/motorhome_indigo.82589235.svg";